<div [soti-tooltip]="getTooltipText()" class="assist-mat-tooltip" placement="top" position="top">
  <ng-content></ng-content>
</div>
